import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@vp/swan';

export const ModWrapperWithPadding = ({ children }) => (
  <Box mb={3}>{children}</Box>
);

ModWrapperWithPadding.propTypes = {
  children: PropTypes.element,
};
